"use client";

import { MDXContent } from "@content-collections/mdx/react";
import { cn } from "@repo/ui";
import { mdxComponents } from "../utils/mdx-components";

interface PostContentProps {
	content: string;
	className?: string;
}

export function PostContent({ content, className }: PostContentProps) {
	return (
		<div
			className={cn(
				"prose dark:prose-invert mx-auto mt-6 max-w-2xl",
				className,
			)}
		>
			<MDXContent
				code={content}
				components={{
					a: mdxComponents.a,
				}}
			/>
		</div>
	);
}
